export const events = {
  bulkActions: {
    clientAssignment: {
      eventStart: 'bulk_client_projects_assignment',
      eventSubmit: 'bulk_client_rojects_assignment_submit',
    },
    employeeProjectsAssignment: {
      eventStart: 'bulk_employee_projects_assignment',
      eventSubmit: 'bulk_employee_projects_assignment_submit',
    },
    roleProjectsAssignment: {
      eventStart: 'bulk_role_projects_assignment',
      eventSubmit: 'bulk_role_projects_assignment_submit',
    },
    upgrade: {
      cancelUpgradeModal: 'Cancel bulk actions for projects upgrade request',
      confirmUpgradeModal: 'Confirm bulk actions for projects upgrade request',
      visitUpgradeModal: 'Visit request upgrade modal for bulk actions for projects',
    },
  },

  clients: {
    list: {
      clientListProjectUnlink: 'Client project list project unlink',
      goToProject: 'Client project list go to project',
    },
    wizard: {
      addClientProjectSubmitProjectWizard: 'Add client project submit project wizard',
      createProjectClientButtonProjectWizard: 'Create client project button project wizard',
    },
  },

  contributors: {
    visitContributorsListSection: 'Visit contributors list section',
    visitContributorViewSection: 'Visit contributor view section',
  },

  flexibleTracking: {
    addProjectFromFlexibleTable: 'Add project from projects flexible tracking table',
    createCommentInFlexibleTable: 'Create a comment in projects flexible tracking table',
    createFavouriteProject: 'Create a favourite project',
    createHoursInFlexibleTable: 'Create hours in projects flexible tracking table',
    deleteFavouriteProject: 'Delete a favourite project',
    filterSelected: 'My projects table filter selected',
    hints: {
      closeAddProjectHintWithProjects: 'Close Add Project hint with projects',
      closeAddProjectHintWithoutProjects: 'Close Add Project hint without projects',
      closeMyProjectsViewEmployee: 'Close my projects view hint - employee',
      closeMyProjectsViewManager: 'Close my projects view hint - manager',
      nextProjectHintWithProjects: 'Next project hint with projects',
      nextProjectHintWithoutProjects: 'Next project hint without projects',
      visitAddProjectHintWithProjects: 'Visit Add Project hint with projects',
      visitAddProjectHintWithoutProjects: 'Visit Add Project hint without projects',
      vistiMyProjectsViewEmployee: 'Visit My projects view hint Clock-in page - employee',
      vistiMyProjectsViewManager: 'Visit My projects view hint Clock-in page - manager',
    },
    overview: {
      goToProjectDetail: 'Go to project detail from contributor view',
      goToTaskDetail: 'Go to task detail from contributor view',
      myProjectsOverviewFilterSelected: 'My projects overview filter selected',
      openOneProjectPendingTasksSidePanel: 'Open one project pending tasks side panel',
      openProjectsPendingTasksSidePanel: 'Open projects pending tasks side panel',
      visitMyProjectsOverviewSection: 'Visit my projects overview section',
    },
    updateHoursInFlexibleTable: 'Update hours in projects flexible tracking table',
    visitMyProjectsSection: 'Visit my projects section',
    visitMyProjectsTrackingSection: 'Visit my projects tracking section',
    visitPopupWindowForChangingTime: 'Visit pop-up window for changing time',
    visitMyProjectsScheduleSection: 'Visit my projects schedule section',
  },

  hints: {
    closeDocumentsHint: 'Close documents hint',
    closeKanbanSelectorHint: 'Close kanban selector hint',
    closeScheduleOnboardingHint: 'Close schedule onboarding hint',
    closeScheduleMyProjectsHint: 'Close schedule my projects hint',
    closeTaskDetailsHint: 'Close task details hint',
    viewDocumentsHint: 'View documents hint',
    viewKanbanSelectorHint: 'View kanban selector hint',
    viewScheduleOnboardingHint: 'View schedule onboarding hint',
    viewScheduleMyProjectsHint: 'View schedule my projects hint',
    viewTaskDetailsHint: 'View task details hint',
  },

  importProjects: {
    cancelConfirmImportProjects: 'Confirm import projects cancel',
    confirmImportProjectsStart: 'Confirm import projects start',
    confirmImportProjectsSubmit: 'Confirm import projects submit',
    confirmImportProjectsSuccess: 'Confirm import projects success',
    downloadImportProjectsTemplate: 'Download import projects template',
    emptyFileUploaded: 'Empty file uploaded',
    importProjectsStart: 'Import projects start',
    importProjectsSubmit: 'Import projects submit',
    invalidFileFormatUploaded: 'Invalid file format uploaded',
    upgrade: {
      cancelUpgradeModal: 'Cancel import projects upgrade request',
      confirmUpgradeModal: 'Confirm import projects upgrade request',
      visitUpgradeModal: 'Visit request upgrade modal for import projects',
    },
    uploadFileForProjectImport: 'Upload file for project import',
    visitImportProjectsDetailsPage: 'Visit import projects details page',
    visitImportProjectsErrorsTab: 'Visit import projects errors tab',
  },
  jobsAndRates: {
    clickOnAddJobButton: 'Click on Add job button',
    clickOnCreateNewEmployeeRate: 'Click on Create new employee rate',
    clickOnCreateNewJobLevelRate: 'Click on Create new job level rate',
    clickOnDefineBillRateLink: 'Click on Define bill rate link',
    clickOnDeleteFromList: 'Click on Delete from list',
    clickOnEditEmployeeRate: 'Click on Edit employee rate',
    clickOnEditRoleRate: 'Click on Edit role rate',
    clickOnProjectConfigurationRate: 'Click on project configuration rate',
    clickOnRatesSettings: 'Click on Rates settings',
    clickOnSaveNewEmployeeRate: 'Click on Save new employee rate',
    clickOnSaveNewJobLevelRate: 'Click on Save new job level rate',
    clickOnSaveIndividualBillRate: 'Save individual bill rate inside a project',
    clickOnSaveJobsAndRatesButton: 'Save jobs and rates button',
    clickOnSeeAllJobsButton: 'Click on See all jobs button',
    visitJobsAndRatesSection: 'Visit Jobs and rates section',
  },
  myProjects: {
    commentsSidepanel: {
      clickOnEditComment: 'Click on edit comment',
      clickOnSaveComment: 'Click on save comment',
      open: 'Open comments sidepanel',
    },
  },

  laborCost: {
    modals: {
      clickPermissionsConfigLaborCostModal: 'click permissions config labor cost modal',
      closeConfigLaborCostModal: 'Close config labor cost modal',
      visitConfigLaborCostModal: 'Visit config labor cost modal',
    },
  },

  onboarding: {
    clickLetsGetStarted: "Click on Let's get started projects Onboarding page",
    showOnboarding: 'Show Projects Onboarding Page',
  },

  overview: {
    clickLandingOverviewSection: 'Click on the upgrade plan button on the landing page',
    clickOnHoursEvolutionLegend: 'Click on hours evolution legend',
    projectsOverviewFilterSelected: 'Projects overview filter selected',
    projectsOverviewGraphSelected: 'Projects overview graph selected',
    seeBreakdownChart: 'See breakdown chart',
    seeDistributionChart: 'See distribution chart',
    seeEvolutionChart: 'See evolution chart',
    visitOverviewSection: 'Visit the Overview section',
  },

  projectFiles: {
    clickOnCancelDeleteFile: 'Click on cancel delete file',
    clickOnConfirmDeleteFile: 'Click on confirm delete file',
    clickOnDeleteFile: 'Click on delete file',
    clickOnDownloadFile: 'Click on download file',
    clickOnUploadConfirmation: 'Click on upload confirmation',
    clickOnUploadFile: 'Click on upload file',
    visitProjectFilesTab: 'Visit project files tab',
  },

  projectLog: {
    upsell: {
      cancelUpsell: 'Cancel upsell',
      confirmUpsell: 'Confirm upsell',
    },
  },

  projects: {
    addProjectConfirmBasicInformation: 'Confirm basic information',
    addProjectRoles: 'Add project roles',
    addProjectStart: 'Add project start',
    addProjectSubmit: 'Add project submit',
    changeProjectStatusStart: 'Change project status start',
    changeProjectStatusSubmit: 'Change project status submit',
    changeStatus: 'Changed projects status in list',
    deleteProjectStart: 'Delete project start',
    deleteProjectSubmit: 'Delete project submit',
    details: {
      clickMoreInformation: 'Click on more information',
    },
    downloadProjectsReportStart: 'Download projects report start',
    downloadProjectsReportSubmit: 'Download projects report submit',
    duplicateProject: {
      duplicateIndividually: 'Duplicate individually',
      duplicateProjectCancelled: 'Duplicate project cancelled',
      duplicateProjectConfirmed: 'Duplicate project confirmed',
      duplicateProjectOptions: 'Duplicate project options',
      duplicateProjectStart: 'Duplicate project start',
      duplicateProjectSubmit: 'Duplicate project submit',
    },
    editProjectStart: 'Edit project start',
    goToProjectDetails: 'Go to project details',
    goToProjectDetailsEmployees: 'Go to project details employees',
    goToProjectSection: 'Entering on projects/list',
  },

  projectTimeRecords: {
    recordProjectTimeStart: 'Record project time start',
    recordProjectTimeSubmit: 'Record project time end',
  },

  projectWorker: {
    assignEmployeesToProjectStart: 'Assign employees to project start',
    assignEmployeesToProjectSubmit: 'Assign employees to project submit',
  },

  projectWorkers: {
    openProjectWorkerLaborCostMonthDetail: 'Open project worker labor cost month detail',
    openProjectWorkersPanel: 'Open project workers panel',
  },

  salesInvoices: {
    banner: {
      clickSeeAllInvoices: 'Click on see all invoices',
      clickRequestInformation: 'Click on request information',
    },
    upsellModal: {
      cancelUpsellModal: 'Cancel upsell modal',
      confirmUpsellModal: 'Confirm upsell modal',
    },
    viewInvoicesTab: 'View invoices tab',
  },

  schedule: {
    viewSchedulePage: 'View Schedule page',
    clickAssignHoursButton: 'Click on Assign hours button',
    clickAssignButtonEmployee: 'Click on Assign button - employee',
    selectProjectInModal: 'Select project in modal',
    selectSubprojectInModal: 'Select subproject in modal',
    selectDatesInModal: 'Select dates in modal',
    selectHoursInModal: 'Select hours in modal',
    selectEmployeeInModal: 'Select employee in modal',
    clickOnSaveInModal: 'Click on Save in modal',
    clickOnCancelInModal: 'Click on Cancel in modal',
    clickOnDeleteInModal: 'Click on Delete in modal',
    clickOnUpdateInModal: 'Click on Update in modal',
    clickOnProjectsFilter: 'Click on Projects filter',
  },

  settings: {
    addBudget: 'Add budget',
    addRole: 'Add new role',
    deleteBudget: 'Delete budget',
    projectFinancialDetailsProjectSettings: 'Project financial details project settings',
    removeRole: 'Remove role',
    updateBudget: 'Update budget',
    updateProject: 'Update project',
    updateRole: 'Update existing role',
    viewLog: 'Log view',
    visitProjectSettings: 'Visit project settings page',
    changeStatus: 'Changed projects status in settings',
  },

  spending: {
    visitSpendingSection: 'Visit the Spending section',
    clickOnCreateExpense: 'Click on create expense',
    clickOnCreatePurchaseInvoice: 'Click on create purchase invoice',
  },

  subprojects: {
    addSubprojectStart: 'Add subproject start',
    addSubprojectSubmit: 'Add subproject submit',
    deleteSubprojectStart: 'Delete subproject start',
    deleteSubprojectSubmit: 'Delete subproject submit',
    editSubprojectStart: 'Edit subproject start',
    editSubprojectSubmit: 'Edit subproject submit',
    goToProjectDetailsSubproject: 'Go to project details subproject',
    openSubprojectDetails: 'Open subproject details',
  },

  tasks: {
    addComment: 'Add comment to task',
    bulkDeleteProjectTask: 'Bulk delete project task',
    createProjectTaskButton: 'Create project task button',
    duplicateProjectTask: 'Duplicate project task',
    editProjectTask: 'Edit project task',
    employeeTasksVisits: 'Employee task visits',
    submitCreateProjectTask: 'Submit create project task',
    submitEditProjectTask: 'Submit edit project task',
    switchView: 'Switch view',
    updateTaskStatus: 'Update task status',
    visitProjectTasks: 'Visit project tasks',
  },

  wizard: {
    AddProjectSubmitProjectWizard: 'Add project submit project wizard',
    confirmBasicInformationProjectWizard: 'Confirm basic information project wizard',
    createProjectButtonProjectWizard: 'Create project button project wizard',
    projectFinancialsDetailsProjectWizard: 'Project financials details project wizard',
    projectRolesProjectWizard: 'Project roles project wizard',
  },
}
